import axios from '../request/http';
import {toFormData} from '../common/descriptions'
const mantiopl = {
    // banner分页查询
    getBannerPage(params){
        return axios.get("/hemei-admin/banner/getBannerPage", { params });
    },
    // 删除banner
    delBanner(params){
        return axios.delete("/hemei-admin/banner/delBanner", { params });
    },
    // 添加或编辑banner
    addOrUpdBanner(data){
        return axios.post("/hemei-admin/banner/addOrUpdBanner", data);
    },
    // 获取反馈建议列表信息
    getFeedbackPage(params){
        return axios.get("/hemei-admin/feedback/getFeedbackPage", { params });
    },
    // 获取举报信息列表信息
    getReportPage(params){
        return axios.get("/hemei-admin/report/getReportPage", { params });
    },
    // 电话本列表
    getPhoneBookPage(params){
        return axios.get("/hemei-admin/phoneBook/getPhoneBookPage", { params });
    },
    // 添加或编辑电话本
    addOrUpdPhoneBook(data){
        return axios.post("/hemei-admin/phoneBook/addOrUpdPhoneBook", data);
    },
    // 获取用户列表数据
    pageList(params){
        return axios.get("/hemei-admin/user/pageList", { params });
    },
    // 修改账号状态
    update(data){
        return axios.post("/hemei-admin/user/update", toFormData(data));
    },
    // 电商销售数据接口
    dataS(params){
        return axios.get("/hemei-admin/dashboard/ECommerce/data", { params });
    },
}

export default mantiopl;


// WEBPACK FOOTER //
// ./src/api/mantiopl.js